import IPS = require("publicsector");
import Services = require("../../services");

class Service extends Services.BusinessService<IPS.GeoEntity> {

    static about = `service proxy for cdr/applications/businesslicense`;

    constructor(public api: Services.API) {
        super(api, "cdr/applications/businesslicense");
    }

}

export = Service;  